<app-dialog-header [title]="isCreate ? 'general.api_translations_form_create_title' : 'general.api_translations_form_edit_title'"
                   [withConfirm]="true" (closed)="confirmClose()"></app-dialog-header>
<mat-dialog-content>
  <!-- Key -->
  <app-text-input [label]="'general.api_translations_table_key'" [(value)]="translation.key"></app-text-input>
  <hr>
  <!-- Translations -->
  <app-label-value [label]="'general.api_translations_form_translations'" [template]="translationsTemplate" [withMargin]="true"></app-label-value>
  <ng-template #translationsTemplate>
    <div class="flex flex-column">
      <app-text-input *ngFor="let language of sortedLanguages" [label]="'general.api_translations_table_lang_' + language"
                      [(value)]="translation.translations[language]" [required]="language === 'en'"></app-text-input>
    </div>
  </ng-template>
  <br>
</mat-dialog-content>
<app-dialog-footer [dialogActions]="dialogActions"></app-dialog-footer>
<ng-template #dialogActions>
  <button mat-button (click)="confirmClose()">{{(!isCreate && !isEdit ? 'general.api_general_close' : 'general.api_translations_form_cancel')  | translate}}</button>
  <button mat-flat-button color="primary" *ngIf="isCreate" [disabled]="!isValid" (click)="isValid && create()">{{'general.api_translations_form_create' | translate}}</button>
  <button mat-flat-button color="primary" *ngIf="isEdit" [disabled]="!isValid" (click)="isValid && update()">{{'general.api_translations_form_save' | translate}}</button>
</ng-template>
